
import React from 'react'
import '../Blog/Blog.css'

function Blog() {
  return (
    <div className='new2_bg'>

<section
  className="elementor-section elementor-top-section elementor-element elementor-element-76ee287 animated-fast elementor-section-boxed elementor-section-height-default elementor-section-height-default animated fadeIn"
  data-id="76ee287"
  data-element_type="section"
  data-settings='{"animation":"fadeIn","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
>
  <div className="elementor-container elementor-column-gap-no">
    <div
      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e75a1e"
      data-id="3e75a1e"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <section
          className="elementor-section elementor-inner-section elementor-element elementor-element-0a7722a elementor-section-full_width animated-fast elementor-section-height-default elementor-section-height-default animated bounceInUp"
          data-id="0a7722a"
          data-element_type="section"
          data-settings='{"animation":"bounceInUp","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c8c783d" data-id="c8c783d" data-element_type="column">
              <div className="elementor-widget-wrap"></div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-0d5f116"
              data-id="0d5f116"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-5eb2b9b elementor-widget__width-initial center elementor-widget elementor-widget-wdt-heading"
                  data-id="5eb2b9b"
                  data-element_type="widget"
                  data-settings='{"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-heading.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-heading-holder"
                      id="wdt-heading-5eb2b9b"
                    
                    >
                      <div className="wdt-heading-subtitle-wrapper wdt-heading-align-center">
                        <span className="wdt-heading-subtitle-centerr" >
                          News &amp; Blogs
                        </span>
                      </div>
                      <h2    className="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                        <span className="wdt-heading-title">
                          Boosting The Development Of Children's Brain &amp;
                          Motor Skills
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9b8c5f5"
              data-id="9b8c5f5"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap"></div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-inner-section elementor-element elementor-element-31fbf1d elementor-section-full_width animated-fast elementor-section-height-default elementor-section-height-default animated bounceInUp"
          data-id="31fbf1d"
          data-element_type="section"
          data-settings='{"animation":"bounceInUp","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-31d9a3e"
              data-id="31d9a3e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-f09eb58 elementor-widget elementor-widget-wdt-blog-posts"
                  data-id="f09eb58"
                  data-element_type="widget"
                  data-settings='{"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-blog-posts.default"
                >
                  <div className="elementor-widget-container">
                    <div className="wdt-posts-list-wrapper  wdt-post-list-carousel-f09eb58">
                      <div
                        className="tpl-blog-holder  apply-isotope"
                        style={{ position: "relative", height: "390.112px" }}
                      >
                        <div
                          className="grid-sizer  entry-grid-layout wdt-simple-style wdt-scalein-hover wdt-default-overlay alignleft column wdt-one-third wdt-post-entry"
                          style={{ position: "absolute", left: 0, top: 0 }}
                        />
                        <div
                          className="entry-grid-layout wdt-simple-style wdt-scalein-hover wdt-default-overlay alignleft column wdt-one-third wdt-post-entry"
                          style={{ position: "absolute", left: 0, top: 0 }}
                        >
                          <article
                            id="post-27585"
                            className="post-27585 post type-post status-publish format-standard has-post-thumbnail hentry category-nursery blog-entry"
                          >
                            {/* Featured Image */}
                            <div className="entry-thumb">
                              <a
                                href="https://dtthemes.kinsta.cloud/a-for-apple/the-ultimate-guide-to-creating-a-positive-classroom-environment/"
                                title="Permalink to The Ultimate Guide to Creating a Positive Classroom Environment."
                              >
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={1230}
                                  height={502}
                                  src="./pic1.webp"
                                  className="attachment-wdt-blog-iii-column size-wdt-blog-iii-column wp-post-image"
                                  alt=""
                                  srcSet="./pic1.webp 1230w,  ./pic1.webp 300w,  ./pic1.webp 1024w,  ./pic1.webp 768w,  ./pic1.webp 1000w"
                                  sizes="(max-width: 1230px) 100vw, 1230px"
                                />
                              </a>
                            </div>
                            {/* Featured Image */}
                            {/* Entry Date */}
                            {/* <div className="entry-date">
                              <i className="wdticon-calendar"> </i>
                         
                            </div> */}
                            {/* Entry Date */}
                            <div className="entry-meta-group">
                              {/* Entry Categories */}
                              <div className="entry-categories">
                                <a href="/Ourprograms">
                                  Pre Nursery
                                </a>
                              </div>
                              {/* Entry Categories */}
                              {/* Entry Author */}
                              {/* <div className="entry-author">
                                <i className="wdticon-user"> </i>
                                <a
                                  href="https://dtthemes.kinsta.cloud/a-for-apple/author/wdtadmin/"
                                  title="View all posts by wdtadmin"
                                >
                                  wdtadmin
                                </a>
                              </div> */}
                              {/* Entry Author */}
                            </div>
                            {/* Entry Title */}
                            <div className="entry-title">
                              <h4>
                                {" "}
                                <a
                                  href=""
                                  title="Permalink to The Ultimate Guide to Creating a Positive Classroom Environment."
                                >
                                  The Ultimate Guide to Creating a Positive
                                  Classroom Environment.
                                </a>
                              </h4>
                            </div>
                            {/* Entry Title */}
                            <div className="entry-body">
                              <p>
                              Our Pre-Nursery program is designed to nurture and stimulate the youngest minds through a variety of engaging and age-appropriate activities.
                              </p>
                            </div>
                            {/* Entry Button */}
                            <div className="entry-button wdt-core-button">
                              <a
                                href="/Ourprograms"
                                title="The Ultimate Guide to Creating a Positive Classroom Environment."
                                className="wdt-button"
                              >
                                Read More
                                <span>
                                  <svg
                                
                                   
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 59"
                                    style={{
                                      enableBackground: "new 0 0 100 59"
                                    }}
                                   
                                  >
                                    <polygon points="59.9,6.1 79.4,25.7 6,25.7 6,33.3 79.4,33.3 59.9,52.9 65.3,58.2 94,29.5 65.3,0.8 " />
                                  </svg>
                                </span>
                              </a>
                            </div>
                            {/* Entry Button */}
                          </article>
                        </div>
                        <div
                          className="entry-grid-layout wdt-simple-style wdt-scalein-hover wdt-default-overlay alignleft column wdt-one-third wdt-post-entry"
                          style={{
                            position: "absolute",
                            left: "496.35px",
                            top: 0
                          }}
                        >
                          <article
                            id="post-27582"
                            className="post-27582 post type-post status-publish format-standard has-post-thumbnail hentry category-nursery blog-entry"
                          >
                            {/* Featured Image */}
                            <div className="entry-thumb">
                              <a
                                href=""
                                title="Permalink to Tips For Creating A Productive Study Space At Home For Kids."
                              >
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={1230}
                                  height={502}
                                  src="./pic2.webp"
                                  className="attachment-wdt-blog-iii-column size-wdt-blog-iii-column wp-post-image"
                                  alt=""
                                  srcSet="./pic2.webp 1230w,  ./pic2.webp 300w,  ./pic2.webp 1024w,  ./pic2.webp 768w,  ./pic2.webp 1000w"
                                  sizes="(max-width: 1230px) 100vw, 1230px"
                                />
                              </a>
                            </div>
                            {/* Featured Image */}
                            {/* Entry Date */}
                            {/* <div className="entry-date">
                              <i className="wdticon-calendar"> </i>
                              08 Mar
                            </div> */}
                            {/* Entry Date */}
                            <div className="entry-meta-group">
                              {/* Entry Categories */}
                              <div className="entry-categories">
                                <a href="/Ourprograms">
                                 Nursery
                                </a>
                              </div>
                              {/* Entry Categories */}
                              {/* Entry Author */}
                              
                              {/* Entry Author */}
                            </div>
                            {/* Entry Title */}
                            <div className="entry-title">
                              <h4>
                                {" "}
                                <a
                                  href="https://dtthemes.kinsta.cloud/a-for-apple/tips-for-creating-a-productive-study-space-at-home-for-kids/"
                                  title="Permalink to Tips For Creating A Productive Study Space At Home For Kids."
                                >
                                  Tips For Creating A Productive Study Space At
                                  Home For Kids.
                                </a>
                              </h4>
                            </div>
                            {/* Entry Title */}
                            <div className="entry-body">
                              <p>
                              Our Nursery program provides a balanced mix of academic readiness and social-emotional learning through structured play and educational activities.
                              </p>
                            </div>
                            {/* Entry Button */}
                            <div className="entry-button wdt-core-button">
                              <a
                                href="/Ourprograms"
                                title="Tips For Creating A Productive Study Space At Home For Kids."
                                className="wdt-button"
                              >
                                Read More
                                <span>
                                  <svg
                                    
                                    
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 59"
                                    style={{
                                      enableBackground: "new 0 0 100 59"
                                    }}
                                   
                                  >
                                    <polygon points="59.9,6.1 79.4,25.7 6,25.7 6,33.3 79.4,33.3 59.9,52.9 65.3,58.2 94,29.5 65.3,0.8 " />
                                  </svg>
                                </span>
                              </a>
                            </div>
                            {/* Entry Button */}
                          </article>
                        </div>
                        <div
                          className="entry-grid-layout wdt-simple-style wdt-scalein-hover wdt-default-overlay alignleft column wdt-one-third wdt-post-entry"
                          style={{
                            position: "absolute",
                            left: "992.7px",
                            top: 0
                          }}
                        >
                          <article
                            id="post-27579"
                            className="post-27579 post type-post status-publish format-standard has-post-thumbnail hentry category-kindergarten blog-entry"
                          >
                            {/* Featured Image */}
                            <div className="entry-thumb">
                              <a
                                href="https://dtthemes.kinsta.cloud/a-for-apple/fun-and-educational-activities-to-boost-childrens-learning-ability/"
                                title="Permalink to Fun And Educational Activities To Boost Children’s Learning Ability."
                              >
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width={1230}
                                  height={502}
                                  src="./pic3.webp"
                                  className="attachment-wdt-blog-iii-column size-wdt-blog-iii-column wp-post-image"
                                  alt=""
                                  srcSet="./pic3.webp 1230w,  ./pic3.webp 300w,  ./pic3.webp 1024w,  ./pic3.webp 768w,  ./pic3.webp 1000w"
                                  sizes="(max-width: 1230px) 100vw, 1230px"
                                />
                              </a>
                            </div>
                            {/* Featured Image */}
                            {/* Entry Date */}
                            
                            {/* Entry Date */}
                            <div className="entry-meta-group">
                              {/* Entry Categories */}
                              <div className="entry-categories">
                                <a href="/Ourprograms">
                                  LKG
                                </a>
                              </div>
                              {/* Entry Categories */}
                              {/* Entry Author */}
                              
                              {/* Entry Author */}
                            </div>
                            {/* Entry Title */}
                            <div className="entry-title">
                              <h4>
                                {" "}
                                <a
                                  href="https://dtthemes.kinsta.cloud/a-for-apple/fun-and-educational-activities-to-boost-childrens-learning-ability/"
                                  title="Permalink to Fun And Educational Activities To Boost Children’s Learning Ability."
                                >
                                  Fun And Educational Activities To Boost
                                  Children’s Learning Ability.
                                </a>
                              </h4>
                            </div>
                            {/* Entry Title */}
                            <div className="entry-body">
                              <p>
                              Our LKG program is designed to build a strong foundation in early academics while promoting independence and self-confidence and Many More.
                              </p>
                            </div>
                            {/* Entry Button */}
                            <div className="entry-button wdt-core-button">
                              <a
                                href="/Ourprograms"
                                title="Fun And Educational Activities To Boost Children’s Learning Ability."
                                className="wdt-button"
                              >
                                Read More
                                <span>
                                  <svg
                                    
                                   
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 59"
                                    style={{
                                      enableBackground: "new 0 0 100 59"
                                    }}
                                   
                                  >
                                    <polygon points="59.9,6.1 79.4,25.7 6,25.7 6,33.3 79.4,33.3 59.9,52.9 65.3,58.2 94,29.5 65.3,0.8 " />
                                  </svg>
                                </span>
                              </a>
                            </div>
                            {/* Entry Button */}
                          </article>
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>

    </div>
  )
}

export default Blog